module.exports = "https://r.zoocdn.com/_next/static/images/sold-property-cluster-pin-301d31df33034dfe18a83b70a0531060.svg";